import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/Shared";
import { cn } from "lib/utils";

export const ErrorPage = () => {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.href = "/";
    window.location.reload();
  };

  return (
    <div className="bg-muted flex min-h-screen flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <div className={cn("flex flex-col gap-6")}>
          <div className="overflow-hidden rounded-xl border bg-card text-card-foreground shadow-xl">
            <div className="grid p-0 md:grid-cols-2">
              <div className="flex flex-col gap-6 p-14 justify-center items-center">
                <div className="text-center space-y-4">
                  <h1 className="text-2xl font-bold tracking-tight">
                    {t("Page not found")}
                  </h1>
                  <p className="text-muted-foreground">
                    {t(
                      "Something went wrong or the page you are looking for does not exist.",
                    )}
                  </p>
                </div>
                <Button onClick={handleReload} className="w-full">
                  {t("Reload")}
                </Button>
              </div>

              <div className="bg-muted relative hidden md:block aspect-square md:aspect-auto">
                <img
                  src="/images/background.png"
                  alt="Error Background"
                  className="inset-0 h-full w-full object-cover absolute"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      console.info(this.state);
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
